import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, Groups} from "@leap4/frontend";
import type {GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {PublisherLoginsBaseUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";
import {Link} from "react-router-dom";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

const fields = {
    advertiserName: 1,
    publisherName: 1,
}

const getParams: IGetAllParams = {
    fields
}
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${PublisherLoginsBaseUrl}`
    }, fields, {
        created: {},
        isActive: {},
        updated: {},
        name: {editLinkFunc: (id: string) => urlService.editPublisherLogins(id)}
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
    const advertiserCol = columns.find(x => (x.field === "advertiserName"));
    const publisherCol = columns.find(x => (x.field === "publisherName"));
    publisherCol.headerName = "Publisher"
    advertiserCol.headerName = "Advertiser"
    advertiserCol.renderCell = (params: GridRenderCellParams) => {
        return <Link to={urlService.editPublisherLogins(params.id.toString())}><strong>{params.value}</strong></Link>
    };
    publisherCol.renderCell = (params: GridRenderCellParams) => {
        return <Link to={urlService.editPublisherLogins(params.id.toString())}><strong>{params.value}</strong></Link>
    };
}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const PublisherLoginsDashboardModule = (props:PropsFromRedux) => {
    setStoreAndColumns();

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.publisherLogins(),
                text: "Publisher logins Dashboard",
                icon: <Groups />
            }}
            tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
            getAllParams={getParams}

        />
    );
};

export default connector(PublisherLoginsDashboardModule)